<template>
  <div class="c-header">
    <div class="container-auto header-box">
      <img class="am-img-responsive" src="@/assets/img/header/text.png" alt="宁波市地方金融监督管理局">
      <a href="https://www.zjzwfw.gov.cn/zjservice-fe/#/home" class="mr-20" target="_blank">
        <img src="@/assets/img/header/zw.png" alt="">
      </a>
      <a href="https://www.ningbo.gov.cn/" target="_blank">
        <img src="@/assets/img/header/rmzf.png" alt="">
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "CHeader"
}
</script>

<style scoped lang="scss">
.c-header {
  width: 100%;
  background: url('~@/assets/img/header/bg.jpg') top center no-repeat #bfd4f8;
  height: 254px;
  position: relative;

  &::after {
    position: absolute;
    top: 46px;
    left: 0;
    content: "";
    width: 100%;
    height: 1px;
    border-bottom: 1px solid rgba(0,0,0,0.1);
  }

  .header-box {
    height: 46px;
    padding-top: 2px;
    display: flex;
    align-items: center;
    position: relative;

    .am-img-responsive {
      position: absolute;
      top: 66px;
      left: 5px;
    }
  }
}
</style>
